import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { Clinic } from "src/app/models/database/clinic";
import { Employee } from "src/app/models/database/employee";
import { LogOut, SetClinic, SetClinicToken, SetEmployee, SetOccupation } from "./session.actions";

export class SessionStateModel {
    employee: Employee
    occupation: string
    clinic: Clinic
    clinicToken: string
}

const initialState: SessionStateModel = {
    employee: null,
    occupation: null,
    clinic: null,
    clinicToken: null
}

@State<SessionStateModel>({
    name: 'session',
    defaults: initialState
})
@Injectable()
export class SessionState {

    @Action(SetEmployee)
    setEmployee({ patchState }: StateContext<SessionStateModel>, { payload }: SetEmployee) {
        patchState({ employee: payload })
    }

    @Action(SetOccupation)
    setOccupation({ patchState }: StateContext<SessionStateModel>, { payload }: SetOccupation) {
        patchState({ occupation: payload })
    }

    @Action(SetClinic)
    setClinic({ patchState }: StateContext<SessionStateModel>, { payload }: SetClinic) {
        patchState({ clinic: payload })
    }

    @Action(SetClinicToken)
    setClinicToken({ patchState }: StateContext<SessionStateModel>, { payload }: SetClinicToken) {
        patchState({ clinicToken: payload })
    }

    @Action(LogOut)
    logOut({ patchState }: StateContext<SessionStateModel>) {
        patchState(initialState)
    }
}